// import useRoles from '@/lib/hooks/useRoles'; // Commented out for performance optimization

const useRole = () => {
  // const { data: rolesData } = useRoles(); // Commented out for performance optimization

  // const roleOptions = rolesData.map(({ name, key }) => ({ name: name ?? '', value: key ?? '' })); // Commented out for performance optimization

  // Return empty role options for faster dashboard loading
  const roleOptions: { name: string; value: string }[] = [];

  return { roleOptions };
};

export default useRole;
